import { styleConstants } from '@paywithextend/components'
import { css } from 'styled-components'

export default css`
  &.ReportTransactionsBoxAndLinks .table {
    display: flex;
    justify-content: center;
    flex-direction: column;
    border-bottom-left-radius: ${styleConstants.borderRadius.box};
    border-bottom-right-radius: ${styleConstants.borderRadius.box};
    overflow: hidden;
  }
`
